// TShirtHeroHeader.tsx
import * as React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../../tgccGlobal';

const imgFile = Tgcc.ResolveUrl('~/images/2022Logo.png');

const blackThemeHeaderStyle: React.CSSProperties = {
    backgroundColor: '#121212', // Changed to pure black for the background
    color: '#fff',
    height: '75px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', // Center content horizontally
    padding: '0 20px',
    position: 'relative', // Needed for absolute positioning of the logo
    '@media (max-width: 768px)': {
        height: '60px',
        padding: '0 10px',
    },
};

const logoContainerStyle: React.CSSProperties = {
    position: 'absolute', // Position the logo absolutely
    left: '20px', // Position from the left side of the header
    top: '50%', // Start from the top of the header
    transform: 'translateY(-50%)', // Center vertically
    '@media (max-width: 768px)': {
        left: '10px',
    },
};

const titleContainerStyle: React.CSSProperties = {
    textAlign: 'center', // Center the title text
    width: '100%', // Take full width to center content properly
};


const imgStyles : React.CSSProperties ={
    cursor:'pointer',
    width:'90px',
    filter: 'invert(100%)',
    height:'90px',
    '@media (max-width: 768px)': {
        width: '70px',
        height: '70px',
    },
};

const headerStyle: React.CSSProperties = {
    fontFamily: "Bangers",
    color: '#fff',
    fontSize: '70px', // Adjust the size as needed
    textAlign: 'center',
    textTransform: 'capitalize',
    margin: '80px 0px 60px',
    animation: 'glow 3s ease-in-out infinite alternate',
};



interface HeroProps { state: Tgcc.GlobalState }
class _TShirtHeroLearnMoreHeader extends React.Component<HeroProps> {
    openDashboard = () => { browserHistory.push(Tgcc.Routes.CampusDashboard) };
    openDesigns = () => { browserHistory.push(Tgcc.Routes.CampusDesignListView) };
    openProducts = () => { browserHistory.push(Tgcc.Routes.CampusProductCategoryListView) };
    openContact = () => { browserHistory.push(Tgcc.Routes.CampusContact) };
    openHowItWorks = () => { browserHistory.push(Tgcc.Routes.CampusHowItWorks) };

    render() {
        return (
            <div style={blackThemeHeaderStyle}>
                <div style={logoContainerStyle}>
                    <a href="https://www.thegraphiccowcompany.com/campus" target="_blank" rel="noopener noreferrer">
                        <img src={imgFile} style={imgStyles} alt="Logo" />
                    </a>
                </div>
                <div style={titleContainerStyle}>
                    {/* <h1 style={headerStyle}>BECOME A T-SHIRT HERO</h1> */}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { 
        state: state
    };
};

export const TShirtHeroLearnMoreHeader = Radium(
    connect(mapStateToProps)(_TShirtHeroLearnMoreHeader)
  );
  
